export function createEvent(event, detail) {
    if (detail === void 0) { detail = {}; }
    var nativeEvent = event.nativeEvent, currentTarget = event.currentTarget, target = event.target, bubbles = event.bubbles, cancelable = event.cancelable, defaultPrevented = event.defaultPrevented, eventPhase = event.eventPhase, isTrusted = event.isTrusted, preventDefault = event.preventDefault, isDefaultPrevented = event.isDefaultPrevented, stopPropagation = event.stopPropagation, isPropagationStopped = event.isPropagationStopped, persist = event.persist, timeStamp = event.timeStamp, type = event.type;
    return {
        nativeEvent: nativeEvent,
        currentTarget: currentTarget,
        target: target,
        bubbles: bubbles,
        cancelable: cancelable,
        defaultPrevented: defaultPrevented,
        eventPhase: eventPhase,
        isTrusted: isTrusted,
        preventDefault: preventDefault,
        isDefaultPrevented: isDefaultPrevented,
        stopPropagation: stopPropagation,
        isPropagationStopped: isPropagationStopped,
        persist: persist,
        timeStamp: timeStamp,
        type: type,
        detail: detail,
    };
}
//# sourceMappingURL=create-event.js.map